<ion-header mode="md">
  <ion-toolbar class="header">
    <div class="logo-container">
      <ion-img class="logo" src="/assets/image/retailerlogo.png" [routerLink]="['/home']" (mouseover)="showHome(true)"
        (mouseout)="showHome(false)">
      </ion-img>
      <span class="button" *ngIf="showHomeText">
        <span class="txt">{{'home'|language:'Home'}}</span>
      </span>
    </div>
    <ion-buttons class="btns" slot="end">
      <!-- <ion-button fill="clear" (click)="walletPage()">
        {{'wallet' |language: 'Wallet'}}
      </ion-button> -->
      <ion-button (click)="gotoMyQr()" (mouseover)="showMyQr(true)" (mouseout)="showMyQr(false)">
        <span class="button-content" *ngIf="showMyQrText">
          <span class="text">{{'scanmyshop'|language:'Scan my shop'}}</span>
        </span>
        <ion-icon class="custom-icon" src="assets/icon/scanMyShop.svg" alt=""></ion-icon>
      </ion-button>
      <ion-button (click)="goToOrder()" (mouseover)="showOrder(true)" (mouseout)="showOrder(false)">
        <span class="button-content" *ngIf="showOrderText">
          <span class="text">{{'order'|language:'Order'}}</span>
        </span>
        <ion-icon class="custom-icon" color="primary" name="bag-outline"></ion-icon>
      </ion-button>
      <ion-button (click)="goToNotification()" (mouseover)="showNotification(true)"
        (mouseout)="showNotification(false)">
        <span class="button-content" *ngIf="showNotificationText">
          <span class="text">{{'notification'|language:'Notification'}}</span>
        </span>
        <ion-icon class="custom-icon" color="primary" name="notifications-outline"></ion-icon>
      </ion-button>
      <ion-button routerLink="/profile" (mouseover)="showProfile(true)" (mouseout)="showProfile(false)">
        <span class="button-content" *ngIf="showProfileText">
          <span class="text">{{'profile'|language:'Profile'}}</span>
        </span>
        <ion-icon class="custom-icon" color="primary" name="person-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>